@if (showBanner) {
    <div [style.background-color]="bannerBackgroundColor" [style.height]="bannerHeight" class="notification-banner">
        <div class="container notification-banner__container">
            <p
                [innerHTML]="bannerText | safeHtml"
                [style.color]="bannerTextColor"
                class="notification-banner__text"
                coreLinkify></p>
        </div>
    </div>
}
